import React, {createContext, useState} from "react";
import {useNavigate, useParams, useSearchParams} from "react-router-dom";
import platformGuard from "../api/gate/platformGuard";
import {Reoverlay} from "reoverlay";
import ErrorModal from "../../components/modals/ErrorModal";
import getPlatformAuthLink from "../api/global/getPlatformAuthLink";
import getState from "../api/gate/getState";
import {divarLinkGenerator, safeRedirect} from "../helpers";
import Platforms from "../defaults/Platforms";

const GateContext = createContext({});

function isInternalService(service) {
    const internalServices = [
        Platforms.DIVAR.APPS.DIVAR_INTERNAL_ESTATE.ID,
        Platforms.DIVAR.APPS.DIVAR_INTERNAL_AUTH.ID,
        Platforms.DIVAR.APPS.DIVAR_INTERNAL_CAR.ID,
        Platforms.DIVAR.APPS.FOREIGNER_AUTH.ID,
    ];

    return internalServices.includes(service);
}

const GateProvider = ({children}) => {
    const [searchParams] = useSearchParams();
    const {id, service: serviceType} = useParams();
    const [postToken, setPostToken] = useState(searchParams.get('post_token'));
    const [state, setState] = useState(searchParams.get('state'));
    const [returnUrl, setReturnUrl] = useState(searchParams.get('return_url'));
    const [ticketUuid, setTicketUuid] = useState(searchParams.get('ticket_uuid'));
    const [code, setCode] = useState(searchParams.get('code'));
    const discountCode = searchParams.get('discount_code');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);

    const handleUpdatePostToken = (value) => {
        setPostToken(value)
    }
    const handleUpdateReturnUrl = (value) => {
        setReturnUrl(value)
    }
    const handleState = (value) => {
        setState(value)
    }
    const handleTicketUuid = (value) => {
        setTicketUuid(value)
    }
    const handleUpdateCode = (value) => {
        setCode(value)
    }
    const isInternal=isInternalService(serviceType);
    const handlePlatformGuard = async (params, onSuccess = () => {
    }) => {
        setLoading(true);
        try {
            const response = await platformGuard(params);
            const {hasError, data, message} = response;
            if (!hasError) {
                onSuccess(data)
            } else {
                Reoverlay.showModal(ErrorModal, {
                    showConfirmButton: true,
                    confirmButtonText: 'بازگشت به دیوار',
                    confirmButtonTheme: 'red',
                    title: 'خطا',
                    message: message,
                    onConfirm: () => {
                        const link = divarLinkGenerator({
                            returnUrl: sessionStorage.getItem('return_url'),

                        }, isInternal);
                        safeRedirect(link, () => {
                            Reoverlay.showModal(ErrorModal, {
                                showConfirmButton: true,
                                confirmButtonText: 'بستن',
                                confirmButtonTheme: 'red',
                                message: 'لینک معتبر نمی باشد.',
                                title: 'خطا',
                                onConfirm: () => {
                                    Reoverlay.hideModal();
                                    navigate('/404')
                                }
                            })
                        })
                    }
                })
            }

        } catch (error) {

        }


    }
    const handleGetState = async (state, onSuccess = () => {
    }) => {
        setLoading(true)
        const response = await getState(state);
        const {hasError, data, message} = response;
        if (!hasError) {
            onSuccess(data);
        } else {
            handleLoading(false)
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                confirmButtonText: 'تلاش مجدد',
                confirmButtonTheme: 'red',
                showConfirmButton: true,
                onConfirm: () => {
                    handleGetPlatformLink();
                    Reoverlay.hideModal();
                }
            })
        }
    }
    const handleLoading = (value) => {
        setLoading(value)
    }
    const handleGetPlatformLink = async (params) => {
        handleLoading(true)
        const response = await getPlatformAuthLink(params);
        const {hasError, data, status, message} = response;
        if (!hasError) {
            if (data.vmid) {
                sessionStorage.setItem('ticket_uuid', data.vmid)
            }
            if (data?.url) {
                safeRedirect(data.url, () => {
                    handleLoading(false)
                    Reoverlay.showModal(ErrorModal, {
                        title: 'خطا',
                        message: 'لینک معتبر نمی باشد.',
                        showCancelButton: true,
                        cancelButtonText: 'بستن',
                        onCancel: () => {
                            Reoverlay.hideModal();
                            navigate('/404')

                        }
                    })
                })
            }
        } else {
            handleLoading(false)
            Reoverlay.showModal(ErrorModal, {
                title: 'خطا',
                message: message,
                confirmButtonText: status === 901 ? "بازگشت به دیوار" : "تلاش مجدد",
                confirmButtonTheme: 'red',
                showConfirmButton: true,
                onConfirm: () => {
                    if (status === 901) {
                        const redirectUrl = divarLinkGenerator({returnUrl});
                        safeRedirect(redirectUrl, () => {
                            Reoverlay.showModal(ErrorModal, {
                                title: 'خطا',
                                message: 'لینک معتبر نمی باشد.',
                                showCancelButton: true,
                                cancelButtonText: 'بستن',
                                onCancel: () => {
                                    Reoverlay.hideModal();
                                    navigate('/404')
                                }
                            })
                        })
                    } else {
                        handleGetPlatformLink();
                        Reoverlay.hideModal();
                    }


                }
            })
        }
    }
    return <GateContext.Provider value={
        {
            postToken,
            handleUpdatePostToken,
            discountCode,
            ticketUuid,
            handleTicketUuid,
            returnUrl,
            handleUpdateReturnUrl,
            code,
            handleUpdateCode,
            state,
            handleState,
            id,
            serviceType,
            handlePlatformGuard,
            handleGetState,
            handleGetPlatformLink,
            loading,
            handleLoading
        }}>
        {children}
    </GateContext.Provider>

}

export {GateContext, GateProvider}